import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const BottomNavigationBarModuleAsyncComponent = AsyncComponent(async () => import('./bottom-navigation-bar-module' /* webpackChunkName: "bottom-navigation-bar-module" */ ));

export const BottomNavigationBarModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <BottomNavigationBarModuleAsyncComponent {...props}/>
  </React.Suspense>
};